import React from 'react';
import { Loader2 } from 'lucide-react';

const TONE_MAP = {
  view: 'text-blue-600 bg-blue-50 border border-blue-200 hover:bg-blue-100 hover:border-blue-300 hover:text-blue-800',
  edit: 'text-orange-600 bg-orange-50 border border-orange-200 hover:bg-orange-100 hover:border-orange-300 hover:text-orange-800',
  approve: 'text-emerald-600 bg-emerald-50 border border-emerald-200 hover:bg-emerald-100 hover:border-emerald-300 hover:text-emerald-800',
  assign: 'text-purple-600 bg-purple-50 border border-purple-200 hover:bg-purple-100 hover:border-purple-300 hover:text-purple-800',
  duplicate: 'text-gray-600 bg-gray-50 border border-gray-200 hover:bg-gray-100 hover:border-gray-300 hover:text-gray-800',
  link: 'text-green-600 bg-green-50 border border-green-200 hover:bg-green-100 hover:border-green-300 hover:text-green-800',
  delete: 'text-red-600 bg-red-50 border border-red-200 hover:bg-red-100 hover:border-red-300 hover:text-red-800',
};

export default function ActionIconButton({
  icon: Icon,
  tone = 'view',
  onClick,
  title,
  disabled = false,
  loading = false,
  className = '',
}) {
  const toneClasses = TONE_MAP[tone] || TONE_MAP.view;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      aria-disabled={disabled || loading}
      title={title}
      aria-label={title}
      className={`inline-flex flex-shrink-0 items-center justify-center w-9 h-9 rounded-full transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${toneClasses} ${className}`}
    >
      {loading ? (
        <Loader2 className="w-5 h-5 flex-shrink-0 animate-spin" style={{ minWidth: '1.25rem', minHeight: '1.25rem' }} />
      ) : (
        <Icon className="w-5 h-5 flex-shrink-0" style={{ minWidth: '1.25rem', minHeight: '1.25rem' }} strokeWidth={2.25} />
      )}
    </button>
  );
}

export { TONE_MAP };
